import type { RouteRecordRaw } from 'vue-router'
import { APP_CONFIG } from '../../../crypto-otc/src/project-config'
import { PageRoutes } from '../../../platform-config/src/router/PageRoutes'

export const B9Routes: RouteRecordRaw[] = [
  ...(APP_CONFIG.isCompliant
    ? [
        {
          path: PageRoutes.LegalCompliance,
          component: () => import('../views/LegalComplianceView/LegalCompliance'),
          meta: {
            title: '执法请求',
          },
        },
      ]
    : []),
]
